import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { PreloaderInterceptor } from './preloader.interceptor';
import { PreloaderService } from './preloader.service';

@NgModule({
  imports: [CommonModule]
})
export class PreloaderControlModule {
  // make instance available in UsePagePreloader decorator without using DI
  public static preloaderServiceInst: PreloaderService;

  constructor(preloaderService: PreloaderService) {
    PreloaderControlModule.preloaderServiceInst = preloaderService;
  }

  public static forRoot(): ModuleWithProviders<PreloaderControlModule> {
    return {
      ngModule: PreloaderControlModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: PreloaderInterceptor,
          multi: true
        }
      ]
    };
  }
}

export * from './preloader.interceptor';
export * from './preloader.service';
